import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import { setSettingByKey } from "@/features/commissionSlice";
import { setGlobalMessage } from "@/features/systemSlice";
import { importDirectSales } from "@/fetch/fetchCommission";
import { getAllPromoter } from "@/fetch/fetchStaff";
import { getProducts } from "@/fetch/fetchStatistics";
import createExcelFile from "@/lib/createExcelFile";
import extractDirectSalesData from "@/lib/extractDirectSalesData";
import CloudDownload from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import _ from "lodash";
import moment from "moment";
import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

const MemoDirectSalesFormRow = React.memo(
  function DirectSalesFormRow({ index, item, productOptions }) {
    const CALCULATION_METHOD = {
      product_commission: "盒仔佣",
      commission_scheme: "大佣",
    };
    return (
      <Stack key={index} sx={{ my: 2 }} direction={"row"} spacing={2}>
        <Stack
          direction={"row"}
          justifyContent="space-between"
          alignItems={"flex-start"}
          sx={{ flex: 7 }}
          spacing={1}
        >
          <DatePicker
            sx={{ flex: 1 }}
            disabled={true}
            id="date"
            name="date"
            label="日期"
            value={item.tx_date}
            renderInput={(params) => <TextField {...params} />}
          ></DatePicker>
          <TextField
            disabled={true}
            sx={{ flex: 1 }}
            defaultValue={`${item.alias} (${item.staff_code})`}
            id="outlined-basic"
            label="員工"
            variant="outlined"
          />
          <ProductAutoComplete
            multiple={false}
            disabled={true}
            sx={{ width: 250, flex: 7 }}
            productOptions={productOptions}
            selectedValue={item.product_id}
          ></ProductAutoComplete>
          <TextField
            disabled={true}
            sx={{ maxWidth: 110, minWidth: 110, flex: 0.5 }}
            value={item.qty}
            type="number"
            id="outlined-basic"
            label="數量"
            variant="outlined"
            InputProps={{
              inputProps: {
                min: 0,
              },
              endAdornment: <InputAdornment position="end">件</InputAdornment>,
            }}
          />
          <TextField
            disabled={true}
            sx={{ flex: 0.5 }}
            defaultValue={`${CALCULATION_METHOD[item.calculation_method]}`}
            id="outlined-basic"
            label="計算方法"
            variant="outlined"
          />
          <TextField
            disabled={true}
            sx={{ flex: 0.5 }}
            defaultValue={`${
              item.calculation_method === "product_commission"
                ? item.calculation_value
                : "N/A"
            }`}
            id="outlined-basic"
            label="每盒佣金"
            variant="outlined"
          />
        </Stack>
      </Stack>
    );
  },
  (prev, next) => {
    return (
      next.index === prev.index &&
      _.isEqual(prev.item, next.item) &&
      _.isEqual(prev.validations, next.validations)
    );
  },
);

export default function DirectSalesFormRows({ disabled, productOptions }) {
  const dispatch = useDispatch();

  const currentDate = useSelector(
    (state) => state.commission.settings.currentDate,
  );
  const directSales = useSelector(
    (state) => state.commission.settings.directSales,
    shallowEqual,
  );

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });
  const handleImportDirectSales = async (e, selectedDate) => {
    try {
      dispatch(
        setGlobalMessage({
          message: {
            severity: "info",
            message: "上載中.....",
            isError: false,
          },
        }),
      );
      let productData = {};
      let userData = {};
      const { data } = await getProducts();
      const { data: users } = await getAllPromoter(true);
      _.forEach(users, (user) => {
        userData[user.customer_code] = {
          ...user,
        };
      });
      _.forEach(data, (d) => {
        productData[`${d.m18_product_code}-${d.region_id}`] = d.id;
      });
      let insertedrecord = 0;
      let updatedRecord = 0;
      let allRow = 0;
      const directSalesData = await extractDirectSalesData(
        e.target.files[0],
        productData,
        userData,
        selectedDate,
      );
      const { data: imported } = await importDirectSales({
        datas: directSalesData,
        date: moment(selectedDate).format("YYYY-MM-01"),
      });
      insertedrecord += parseInt(imported.ins);
      updatedRecord += parseInt(imported.upd);
      allRow += parseInt(imported.all_rows);

      // const { data: setting } = await getSettingById(id);
      dispatch(
        setSettingByKey({
          value: directSalesData,
          key: "directSales",
        }),
      );
      dispatch(
        setGlobalMessage({
          message: {
            severity: "success",
            message: `上載成功,\n新增了${insertedrecord}條紀錄\n更新了${updatedRecord}條紀錄\n共${allRow}條紀錄`,
          },
        }),
      );
    } catch (error) {
      let message = "";
      switch (error.message) {
        case "dateIsNotCorrect":
          message = `上載失敗 \n 原因:日期不正確，數據必須於${moment(
            selectedDate,
          ).format("YYYY年M月")}內`;
          break;
        case "productNotExist":
          message = `上載失敗\n以下產品不存在\n${error.id}`;
          break;
        default:
          message = "上載失敗";
          break;
      }
      dispatch(
        setGlobalMessage({
          message: {
            severity: "error",
            message: message,
            isError: true,
            code: 500,
          },
        }),
      );
    } finally {
    }
  };
  const handleDownloadTemplate = async () => {
    const columns = [
      { header: "Sales Invoice (Product) Order No.", key: "order_id" },
      { header: "Staff Code", key: "staff_code" },
      { header: "Staff Name", key: "staff_name" },
      { header: "Sales Invoice Date", key: "tx_date" },
      { header: "Sales Invoice No", key: "Sales Invoice No" },
      { header: "Customer Code", key: "Customer Code" },
      { header: "Customer Name", key: "Customer Name" },
      { header: "Product | Material Code", key: "product_id" },
      { header: "Product | Material Brief Description", key: "" },
      { header: "Sales Invoice (Product) Quantity (Base Unit)", key: "qty" },
      { header: "Sales Invoice (Product) Amount", key: "amount" },
      { header: "Calculation Method", key: "calculation_method" },
    ];

    createExcelFile(columns, "Direct Sales Template");
  };
  return (
    <React.Fragment>
      {!disabled && (
        <Box
          sx={{
            display: "flex",
            gridTemplateColumns: { sm: "1fr 1fr" },
            gap: 2,
          }}
        >
          <Button
            component="label"
            size="small"
            color={"success"}
            role={undefined}
            variant={"contained"}
            startIcon={<CloudDownload />}
            onClick={() => handleDownloadTemplate()}
          >
            下載範本
          </Button>
          <Button
            component="label"
            size="small"
            color={directSales?.length > 0 ? "success" : "info"}
            role={undefined}
            variant={"contained"}
            startIcon={<CloudUploadIcon />}
          >
            {directSales?.length > 0 ? "重新上載" : "上載"}
            <VisuallyHiddenInput
              type="file"
              onChange={(event) => handleImportDirectSales(event, currentDate)}
            />
          </Button>
        </Box>
      )}
      {_.map(directSales, (item, index) => (
        <React.Fragment>
          <MemoDirectSalesFormRow
            item={item}
            index={index}
            productOptions={productOptions}
            disabled={disabled}
          ></MemoDirectSalesFormRow>
        </React.Fragment>
      ))}
    </React.Fragment>
  );
}
